<template>
  <v-dialog v-model="dialog" width="800" scrollable>
    <v-card min-height="500">
      <v-card-title>
        <v-btn icon @click="back" v-if="selectedReport">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        {{ selectedReport ? selectedReport.data().title : "Select Report" }}
        <v-spacer />
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-5" style="height: 500px; overflow-y: auto">
        <!-- Grid View -->
        <v-row v-if="!selectedReport">
          <v-col cols="12" md="4" v-for="(report, i) in reportForms" :key="i">
            <v-card
              outlined
              hover
              class="text-center fill-height d-flex flex-column justify-center align-center pa-5"
              @click="openReport(report)"
              style="cursor: pointer"
            >
              <v-icon size="64" color="primary" class="mb-3">
                {{ report.data().icon || "mdi-file-chart" }}
              </v-icon>
              <div class="text-h6">
                {{ report.data().title || `Report ${i + 1}` }}
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Form View -->
        <component
          v-else
          :is="selectedReport"
          v-bind="{ toggleDialog: close }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import * as forms from "./forms";

export default {
  name: "LicenseReportsSelector",
  props: {
    value: Boolean,
  },
  data() {
    return {
      selectedReport: null,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        if (!val) {
          setTimeout(() => {
            this.selectedReport = null;
          }, 300);
        }
      },
    },
    reportForms() {
      let f = [];
      Object.keys(forms).map((k) => {
        f.push(forms[k]);
      });
      return f;
    },
  },
  methods: {
    openReport(report) {
      this.selectedReport = report;
    },
    back() {
      this.selectedReport = null;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped></style>
